import React, { useEffect, useState } from "react";
import { useRouteMatch, Switch, Route, useHistory, useLocation } from "react-router";
import LoginPhone from "./Phone";
import LoginCode from "./Code";
import LoginRegister from "./Register";
import { setAuthToken } from "api";
import { connect } from "react-redux";
import { fetchMe } from "store/user/actions";
import { selectUserRegistered, selectUserLoggedIn } from "store/user/reducer";
import routesConfig from "routesConfig";
import { message } from "antd";

function LoginManager({ fetchMe, userLoggedIn, userRegistered }) {
	const { path } = useRouteMatch();
	const history = useHistory();
	const location = useLocation();
	const [codeKey, setCodeKey] = useState(null);
	const [timer, setTimer] = useState(0);
	const handleRegister = () => {
		fetchMe();
		history.push(routesConfig.home);
	};
	const handleVerifySuccess = (res) => {
		setAuthToken(res.token);
		fetchMe();
	};

	const handleCodeSent = ({ codeKey, phone }) => {
		setCodeKey(codeKey);
		message.success(`‍‍‍‍‍‍‍کد ورود به شماره  ${phone} ارسال شد`, 3);
		history.push(routesConfig.verifyCode);
	};

	useEffect(() => {
		if (userLoggedIn) {
			history.push(userRegistered ? routesConfig.home : routesConfig.register);
		}
	}, [userLoggedIn, userRegistered]);

	useEffect(() => {
		if (!codeKey && location.pathname === `${path}/code`) {
			history.push(routesConfig.login);
		}
	}, [codeKey, location]);

	return (
		<Switch>
			<Route path={`${path}/phone`}>
				<LoginPhone onCodeSent={handleCodeSent} {...{ timer, setTimer }} />
			</Route>
			<Route path={`${path}/code`}>
				<LoginCode codeKey={codeKey} onVerifySuccess={handleVerifySuccess} {...{ timer, setTimer }} />
			</Route>
			<Route path={`${path}/register`}>
				<LoginRegister onRegisterSuccess={handleRegister} />
			</Route>
		</Switch>
	);
}

const mapStateToProps = (state) => ({
	userRegistered: selectUserRegistered(state),
	userLoggedIn: selectUserLoggedIn(state),
});

const mapDispatchToProps = {
	fetchMe,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginManager);
